module.exports = "/v2/pages/dashboard/dist/f403df8716cb6633c274e6de6c08b0ba.svg";